import { Button, Stack, Switch, Typography } from "@mui/material";
import React from "react";
import StockTakeSection from "./StockTakeSection";
import { LoadingButton, Loader } from "../../../shared";
import { useIngredientStock } from "../hooks/useIngredientStock";

export const StockTake = ({ optionsUnits, ingredient }) => {
  const {
    stockData,
    onChange,
    onEdit,
    onSubmit,
    validator,
    isLoading,
    isSaving,
    isEditing,
    isChanged,
    buyingUnits,
    alternateNameDisabled,
  } = useIngredientStock({ optionsUnits, ingredient });

  if (isLoading) {
    return <Loader />;
  }
  return (
    <Stack>
      <Stack
        sx={{
          px: "8px",
          py: "16px",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
        direction="row"
      >
        <Typography variant="h6">Stocktake</Typography>
        {isEditing ? (
          <LoadingButton
            loading={isSaving}
            variant="contained"
            size="small"
            sx={{ mt: "8px" }}
            onClick={onSubmit}
            disabled={!isChanged}
          >
            Save
          </LoadingButton>
        ) : (
          <Button
            variant="outlined"
            color="gray2"
            size="small"
            sx={{ mt: "8px" }}
            onClick={onEdit}
          >
            Edit
          </Button>
        )}
      </Stack>
      <Stack sx={{ p: "8px", backgroundColor: "background.default" }}>
        <Stack
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            p: "24px 20px",
            backgroundColor: "background.paper",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
          direction="row"
        >
          <Stack>
            <Typography fontSize="18px" fontWeight={600}>
              Include in Stocktake
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Enable this to include the ingredient in stocktake.
            </Typography>
          </Stack>
          <Switch
            checked={stockData.data.status === 1}
            disabled={!isEditing}
            onChange={(e) =>
              onChange({
                target: {
                  name: "status",
                  value: e.target.checked ? 1 : 0,
                },
              })
            }
          />
        </Stack>
        {stockData.data.status === 1 && (
          <StockTakeSection
            data={stockData.data}
            onChange={onChange}
            validator={validator}
            buyingUnits={buyingUnits}
            alternateNameDisabled={alternateNameDisabled}
            disabled={!isEditing}
          />
        )}
      </Stack>
    </Stack>
  );
};
